import React from "react";
import { useTranslations } from "@jugl-web/utils";
import { useManageAccountsDrawer } from "@web-src/modules/client-support/pages/ClientSupportPage/components/ManageAccountsDrawer/providers/ManageAccountsDrawerContext";
import { useVoiceAccount } from "@web-src/modules/client-support/pages/ClientSupportPage/components/ManageAccountsDrawer/hooks/useVoiceAccount";
import { useSubscriptionV2 } from "@web-src/modules/cx/providers/SubscriptionV2Provider";
import { ChannelTile } from "../ChannelTile";
import { ReactComponent as PhoneCallsIcon } from "./assets/voice.svg";

export const VoiceTile: React.FC<{
  isSelected: boolean;
  onSelect: () => void;
}> = (props) => {
  const { t } = useTranslations();
  const { account, isConnected, createAccount, isCreating } = useVoiceAccount();
  const { openManageAccountDrawer } = useManageAccountsDrawer();
  const { isFree, openSubscriptionDrawer } = useSubscriptionV2();

  return (
    <ChannelTile
      title={t({
        id: "cx-ai-agents-page.voice",
        defaultMessage: "Phone calls",
      })}
      isConnected={isConnected}
      isDisabled={isCreating}
      pricingTooltip={
        isFree && !isConnected
          ? t({
              id: "cx-ai-agents-page.phone-calls-paid-plan-tooltip",
              defaultMessage:
                "Available for Paid Plans only. Upgrade your Plan to get Phone Calls Feature ℹ️",
            })
          : undefined
      }
      onClick={() => {
        if (isConnected) {
          openManageAccountDrawer({ name: "voiceAccount" });
          return;
        }

        if (isFree) {
          openSubscriptionDrawer();
          return;
        }

        createAccount();
      }}
      description={
        isConnected
          ? account?.phone_num || ""
          : t({
              id: "cx-ai-agents-page.voice-connect-description",
              defaultMessage: "Let AI handle the business calls",
            })
      }
      icon={<PhoneCallsIcon />}
      status={
        isConnected
          ? {
              type: "connected",
              text: t({
                id: "common.enabled",
                defaultMessage: "Enabled",
              }),
            }
          : undefined
      }
      {...props}
    />
  );
};
